import { useSuspenseQuery } from "@tanstack/react-query"
import {
  sortAdults,
  sortChildren,
} from "source/myChurchCenter/Profile/households/Household"
import { useSession } from "source/shared/hooks/useSession"
import { Household, HouseholdMember, Person } from "../types/api"

type ResponseData = Household[]
type Included = Array<Person | HouseholdMember>

export function useHouseholds() {
  const {
    data: { id: currentPersonId },
  } = useSession(true)

  return useSuspenseQuery({
    queryKey: [
      `/people/v2/people/${currentPersonId}/households?include=people,household_members`,
    ],
    select: ({
      data,
      included,
    }: {
      data: ResponseData
      included: Included
    }) => {
      const includedHouseholdRecords = included.filter(
        (record) => record.type === "HouseholdMember",
      )
      const includedPersonRecords = included.filter(
        (record) => record.type === "Person",
      )

      return data.map((household) => {
        const {
          id,
          attributes: { name },
        } = household

        const members = household.relationships.people.data.map((person) => {
          const currentPerson = includedPersonRecords.find(
            (includedMember) => includedMember.id === person.id,
          )! as Person
          const associatedHouseholdRecord = includedHouseholdRecords.find(
            (member) =>
              (member as HouseholdMember).relationships.person.data.id ===
              person.id,
          ) as HouseholdMember
          const { birthday, child, demographic_avatar_url, name, status } =
            currentPerson.attributes

          return {
            birthday,
            child,
            demographic_avatar_url,
            householdMemberId: associatedHouseholdRecord?.id,
            personId: person.id,
            name,
            status,
          }
        })
        const currentUser = members.find(
          (member) => member.personId === currentPersonId,
        )
        const adults = members.filter(
          (member) => !member.child && member.personId !== currentPersonId,
        )
        const children = members.filter(
          (member) => member.child && member.personId !== currentPersonId,
        )
        return {
          id,
          householdMembers: [
            currentUser,
            ...sortAdults(adults),
            ...sortChildren(children),
          ],
          householdName: name,
        }
      })
    },
  })
}
